import { ServiceLocationId, ServiceLocationType } from '@dreryk/egabinet-healthcare-provider-published-language-api';
import { VisitLocation } from '@dreryk/egabinet-visit-frontend-api';

import { assertUnreachable } from '~libs.typescript';

export const getServiceLocationIdFromVisitLocation = (visitLocation: VisitLocation): ServiceLocationId => {
   if (typeof visitLocation.serviceProvidingLocationId === 'number') {
      return ServiceLocationId.of(
         ServiceLocationType.SERVICE_PROVIDING_LOCATION,
         visitLocation.serviceProvidingLocationId
      );
   }
   if (typeof visitLocation.healthcareFacilityLocationId === 'number') {
      return ServiceLocationId.of(
         ServiceLocationType.HEALTHCARE_FACILITY_LOCATION,
         visitLocation.healthcareFacilityLocationId
      );
   }
   if (typeof visitLocation.healthcareFacilityUnitId === 'number') {
      return ServiceLocationId.of(ServiceLocationType.HEALTHCARE_FACILITY_UNIT, visitLocation.healthcareFacilityUnitId);
   }
   return assertUnreachable(
      visitLocation.serviceProvidingLocationId ??
         visitLocation.healthcareFacilityLocationId ??
         visitLocation.healthcareFacilityUnitId
   );
};
